import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { pushPageView, resolvePageType } from "@/lib/datalayer";
import { useAuth } from "@/hooks/useAuth";

/**
 * Fires a dataLayer page_view on every route change.
 * Place inside <BrowserRouter>.
 */
const DataLayerPageView = () => {
  const location = useLocation();
  const { user } = useAuth();
  const userRef = useRef(user);
  userRef.current = user;

  useEffect(() => {
    const pageType = resolvePageType(location.pathname);
    const loginStatus = userRef.current ? "logged_in" : "anonymous";
    pushPageView(pageType, loginStatus, {
      user_id: userRef.current?.id,
    });
  }, [location.pathname]);

  return null;
};

export default DataLayerPageView;
